import script from "./DownloadMixin.vue?vue&type=script&lang=js"
export * from "./DownloadMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__